import React from 'react';
import { MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/contact';
import { Eyebrow } from './Eyebrow';
export function Contact() {
  return <section aria-labelledby="contact-heading" className="bg-night-900 py-14 sm:py-20" data-id="element-70" data-mp="35ahxjy50futn">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-71" data-mp="318o2c5dl3j0v">
        <Eyebrow align="center" tone="muted" data-id="element-72" data-mp="2w8s7avmv71xg">
          Contact us
        </Eyebrow>
        <h2 id="contact-heading" className="mt-4 font-display text-3xl leading-[0.98] text-cream sm:text-5xl" data-id="element-73" data-mp="3sxzmllww4esx">
          Questions <span className="text-amber" data-id="element-74" data-mp="3oyic2e2lwrgw">before you buy?</span>
        </h2>
        <p className="mt-4 font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-75" data-mp="3k3uyvbd1zjhm">
          Write to us and we&rsquo;ll get back to you. We answer every message about access,
          content, and refunds.
        </p>

        <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-7 inline-flex max-w-full items-center gap-3 rounded-xl border border-amber/50 bg-night-800 px-5 py-4 text-sm font-semibold text-cream transition-colors duration-150 ease-out hover:border-amber hover:text-amber sm:text-base" data-id="element-76" data-mp="gi5pbfrzmg1n">
          <MailIcon className="h-5 w-5 shrink-0 text-amber" aria-hidden="true" data-id="element-77" data-mp="3b399mx1ef75f" />
          <span className="break-all" data-id="element-78" data-mp="3b16mqlvjlu4x">{SUPPORT_EMAIL}</span>
        </a>
      </div>
    </section>;
}